import { h, Fragment } from 'preact'
import { useState } from 'preact/hooks'
import { tagParser, linkParser, proxymedia } from '../../js/modules/utilities'

export const TuileMessage = ({ theme, title, description, tag, legalNotice, image, alt, CTA: { URL, analytics, label } }) => {
   return (
      <Fragment>
         <a
            href={URL}
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
            class="tuile-message lien-composite-before"
         >
            {tag && (
               <div class="tag">
                  <div class="ob1-tag ob1-tag-primary">{tag}</div>
               </div>
            )}
            <div class="content">
               <div class="left-content">
                  <h3 class="h4 m-0 p-0">
                     <strong class="title" dangerouslySetInnerHTML={{ __html: tagParser(title) }} />
                     <span class="subtitle" dangerouslySetInnerHTML={{ __html: tagParser(description) }} />
                  </h3>
               </div>
               <div class="right-content">
                  <img src={proxymedia(image)} alt={alt || ''} loading="lazy" />
               </div>
            </div>
            <span class="o-link-arrow">{label}</span>
         </a>
         {(legalNotice.content || legalNotice.title) && <LegalNotice {...legalNotice} theme={theme} index="message" />}
      </Fragment>
   )
}

const LegalNotice = ({ showButtonLabel, title, content, theme, index }) => {
   const [legalState, setLegalState] = useState(false)

   const toggleLegals = () => {
      setLegalState(!legalState)
   }

   const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
         toggleLegals()
      }
   }

   return (
      <div class={`offerLegalNotice ${legalState ? 'openContent' : ''}`}>
         <div id={`legalNoticePanel${index}`} class={`contentLegalNotice ${theme === 'white' ? 'bg-white' : 'bg-dark'}`} aria-hidden={!legalState}>
            <span class={`closeLegal ${theme === 'white' ? 'text-dark' : 'text-white'}`} onClick={toggleLegals}>
               &times;
            </span>
            <div class={`contentText ${theme === 'white' ? 'text-dark' : 'text-white'}`}>
               {title && <div class="lead font-weight-bold" dangerouslySetInnerHTML={{ __html: tagParser(title) }}></div>}
               {content && <div dangerouslySetInnerHTML={{ __html: tagParser(linkParser(content)) }}></div>}
            </div>
         </div>
         <span
            class="showButton"
            onClick={toggleLegals}
            onKeyDown={handleKeyDown}
            tabindex="0"
            role="button"
            aria-expanded={legalState}
            aria-pressed={legalState}
            aria-controls={`legalNoticePanel${index}`}
         >
            <span class={`icon icon-info ${theme === 'white' ? 'text-dark' : 'text-white'}`} aria-hidden="true"></span>
            <strong class={theme === 'white' ? 'text-dark' : 'text-white'}>{showButtonLabel}</strong>
         </span>
      </div>
   )
}
